import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar, Modal } from 'reactstrap';
import { withTranslation } from 'react-i18next';

import Alert from '../../../shared/components/Alert';

class LocationModal extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    modal: PropTypes.bool,
    toggle: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    postValue: PropTypes.objectOf(PropTypes.string),
    handleSubmit: PropTypes.func,
    errorMsg: PropTypes.string,
  };

  static defaultProps = {
    title: 'Location',
    modal: false,
    postValue: {},
    handleSubmit: () => {
      console.log('submitted');
    },
    errorMsg: '',
  };

  constructor() {
    super();
    this.state = {};
    this.toggle = this.toggle.bind(this);
  }

  toggle = () => {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  render() {
    const {
      title, modal, toggle, handleChange, postValue, handleSubmit, errorMsg,
    } = this.props;

    return (
      <div>
        <Modal
          isOpen={modal}
          className="modal-dialog--primary modal-dialog--header"
        >
          <div className="modal__header bg_blue">
            <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
            <h4 className="bold-text modal__title">{title.toString()}</h4>
          </div>
          <form id="location_form" onSubmit={handleSubmit}>
            <div className="modal__body p-t-10">
              { errorMsg && (
                <div className="notif_msg">
                  <Alert color="danger" className="alert--colored">
                    <p><span className="fa fa-exclamation">&nbsp;</span> { errorMsg }</p>
                  </Alert>
                </div>
                )
              }
              <div className="form form--horizontal m-t-10">
                <div className="form__form-group">
                  <span className="form__form-group-label">Location Name <b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <input type="text" name="locationName" value={postValue.locationName ? postValue.locationName : ''} placeholder="Location Name" onChange={handleChange} />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Address</span>
                  <div className="form__form-group-field">
                    <textarea name="address" value={postValue.address ? postValue.address : ''} placeholder="Address" onChange={handleChange} />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Type <b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <select name="type" onChange={handleChange} value={postValue.type ? postValue.type : ''}>
                      <option value="">-- Select --</option>
                      <option value="1">Warehouse</option>
                      <option value="2">Logistic</option>
                      <option value="3">Retail Store</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <ButtonToolbar className="modal__footer">
              <Button color="primary">Submit</Button>
              <Button onClick={toggle}>Cancel</Button>
            </ButtonToolbar>
          </form>
        </Modal>
      </div>
    );
  }
}

export default withTranslation('common')(LocationModal);
